import type { MentionToken } from "./MentionToken";

/**
 * 本文をトークン列へ分解する。
 *
 * 表記は `@[表示名](参照)`。表示名と参照を同じトークンへ持たせるのは、名前が変わっても参照が
 * 壊れず、参照が失われても人が読めば意図が残るためである。表示名の終わりは `](` の並びで決める。
 * 名前に `]` が入る枠（`[会社名] 表`・`表[1]`）でも切れない（#133）。
 *
 * **参照の形は問わない。** 以前の実装は `slide:` と `element:` の接頭辞を要求していたが、
 * それはドメインの語であり ui-kit は持たない。参照を「空でなく `)` を含まない文字列」で切る。
 * 結果として `@[a](b)` のような並びもメンションとして読むが、**それを対象として扱うかは
 * 呼び出し側が接頭辞で濾す**ので、生成の挙動は変わらない。
 *
 * 形の合わないもの（`@[名前]` だけ、`(参照)` だけ）は素の文字列として扱う。書きかけの本文で
 * 表示が壊れないようにするため。
 */
export function tokenizeMentions(text: string): MentionToken[] {
    // matchAll はプロジェクトの target では使えないため exec のループで走査する。
    const pattern = /@\[((?:[^\]]|\](?!\())*)\]\(([^)]+)\)/g;
    const tokens: MentionToken[] = [];
    let cursor = 0;
    let m: RegExpExecArray | null;
    while ((m = pattern.exec(text)) !== null) {
        const start = m.index;
        if (start > cursor) tokens.push({ kind: "text", text: text.slice(cursor, start) });
        tokens.push({ kind: "mention", name: m[1], ref: m[2] });
        cursor = start + m[0].length;
    }
    if (cursor < text.length) tokens.push({ kind: "text", text: text.slice(cursor) });
    return tokens;
}
